import { styled } from "styled-components";

export const DeliveryTermsSectionWrapper = styled.div`
  width: 100%;
  justify-content: center;
  display: flex;
`;

export const DeliveryTermsSectionContainer = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  padding: 96px 24px 96px 24px;
`;

export const SubHeadingSection = styled.div`
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  max-width: 100%;
  overflow-wrap: break-word;
`;

export const LinkItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-self: flex-start;
  max-width: 100%;
  overflow-wrap: break-word;
  color: ${({ theme }) => theme.colors.primary.default};

  > a:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const DeliveryTerms = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  padding: 48px;
  border-radius: 24px;
  background: ${({ theme }) => theme.colors.default[50]};
`;

export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
